import React, { useEffect, useRef } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";

const Html5QrcodePlugin = ({ fps, qrbox, disableFlip, qrCodeSuccessCallback }) => {
  const scannerRef = useRef(null);

  useEffect(() => {
    const html5QrcodeScanner = new Html5QrcodeScanner(
      "reader",
      { fps, qrbox },
      disableFlip
    );
    html5QrcodeScanner.render(qrCodeSuccessCallback);

    return () => {
      html5QrcodeScanner.clear().catch(error => {
        console.error("Failed to clear html5QrcodeScanner. ", error);
      });
    };
  }, [fps, qrbox, disableFlip, qrCodeSuccessCallback]);

  return <div id="reader"></div>;
};

export default Html5QrcodePlugin;